<template>
  <CommonModal @onClose="onClose" :title="'Инструкция'">
    <template #body>
      <div :class="$style.container">
        <div :class="$style.content">
          Давно выяснено, что при оценке дизайна и композиции читаемый текст
          мешает сосредоточиться. Lorem Ipsum используют потому, что тот
          обеспечивает более или менее стандартное заполнение шаблона, а также
          реальное распределение букв и пробелов в абзацах, которое не
          получается при простой дубликации "Здесь ваш текст.. Здесь ваш текст..
          Здесь ваш текст.." Многие программы электронной вёрстки и редакторы
          HTML используют Lorem Ipsum в качестве текста по умолчанию, так что
          поиск по ключевым словам "lorem ipsum" сразу показывает, как много
          веб-страниц всё ещё дожидаются своего настоящего рождения. За
          прошедшие годы текст Lorem Ipsum получил много версий. Некоторые
          версии появились по ошибке, некоторые - намеренно (например,
          юмористические варианты).
        </div>
      </div>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modals/CommonModal.vue";
export default {
  components: {
    CommonModal,
  },
  methods: {
    onClose() {
      this.$store.commit("setIconsModals", {
        modal: "info",
        value: false,
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  .content {
    font-weight: 400;
    line-height: 150%;
    max-width: 34.5rem;
    margin: 1.5rem auto 0 auto;
  }
}
</style>
